import { useSelector } from 'react-redux'

import { useLatestEntity } from '@domain-group/react-hooks'

export const generateUrls = () => ({
  rolesIndexUrl: '#/systemManager/roles',
})

function useRole(initEntity = {}){
  const { entity: role } = useLatestEntity(initEntity, 'roles')

  const { loading } = useSelector(reduxState => reduxState.roles)

  return {
    role,
    loading,
    urls: generateUrls(),
  }
}

export default useRole
